import React from 'react';
import cn from 'classnames';
import List from '../List';
import Icon from '../../Icon/Icon';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { FormattedMessage } from 'react-intl';

const View = ({
  data: { name, defaultLabel, search, activeParamsNumber, className, open, data, children, mobileModal, isMobile },
  handleRef,
  toggle,
  uncheckAll,
  clearMobile,
  applyMobile,
  onItemChange,
  checkOnParentIfNeeded,
}) => (
  <div className={cn('filter', className)} ref={handleRef}>
    <button type="button" className={cn('filter-toggle-button', { opened: open })} onClick={toggle}>
      {defaultLabel} {activeParamsNumber > 0 && <span>({activeParamsNumber})</span>}
      <i className="dropdown-toggle" />
    </button>
    {activeParamsNumber > 0 && (
      <button className="filter-reset-button" type="button" onClick={uncheckAll}>
        <Icon type="cross-rounded" />
      </button>
    )}
    {open && !(mobileModal && isMobile) && (
      <List
        search={search}
        items={data}
        name={name}
        onItemChange={onItemChange}
        onSubItemsChange={checkOnParentIfNeeded}
        children={children}
      />
    )}
    {mobileModal && isMobile && (
      <Modal isOpen={open} toggle={toggle} centered className="statistics-filter-modal flow-products-modal">
        <ModalHeader toggle={toggle}>{defaultLabel}</ModalHeader>
        <ModalBody>
          <List
            search={search}
            items={data}
            name={name}
            onItemChange={onItemChange}
            onSubItemsChange={checkOnParentIfNeeded}
            children={children}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={applyMobile}>
            <FormattedMessage id="statistics.filters.apply" defaultMessage="Apply" />
          </Button>
          <Button color="secondary" onClick={clearMobile}>
            <FormattedMessage id="statistics.filters.clear" defaultMessage="Clear" />
          </Button>
        </ModalFooter>
      </Modal>
    )}
  </div>
);


export default View;
